import { CancellationStatuses, Status } from '@/common/enums/Status';

/**
 * Sends a color of the badge for a specific type of reservation status
 *
 * @param {Status} status reservation status
 * @returns {string} color that applies to the reservation status
 */
export const getStatusColor = (status: Status): string => {
	if (CancellationStatuses.includes(status)) {
		return 'red';
	}

	if (status === Status.CONFIRMED) {
		return 'green';
	}

	return 'blue';
};
